<template>
  <li class="">
    <span :class="[{ arrow: node.child?.length }]"></span>
    <router-link :to="node.path" v-html="node.name" />
    <div class="uk-navbar-dropdown" uk-dropdown="pos: right-bottom; offset: 12;" v-if="node.child">
      <ul class="uk-nav uk-navbar-dropdown-nav" v-if="node.child">
        <NavBarRow v-for="node in node.child" :key="node.id" :node="node" />
      </ul>
    </div>
  </li>
</template>
<style lang="scss" scoped>
ul li a {
  color: #fff;
}
.arrow {
  display: block;
  content: "";
  position: absolute;
  right: 10px;
  width: 6px;
  height: 6px;
  margin-top: 12px;
  border-top: solid 2px #fff;
  border-right: solid 2px #fff;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
<script lang="ts">
import { Vue, Options } from "vue-class-component";

interface Node {
  name: String;
  path: String;
  child: Node[];
}

@Options({
  props: {
    node: Object
  }
})
export default class NavBarRow extends Vue {
  node!: Node;
}
</script>
